//LIBRARIES
import React from 'react';
import { Form } from 'antd';

import { leaseCreatorColors } from 'helpers/ColorHelper';

import { InfoMessage } from './InfoMessage';

// STYLES
import styled from 'styled-components';
import { media } from 'helpers/MediaHelper';
import { responsive } from 'helpers/StyleHelper';

const StyledFormItem = styled(Form.Item)`
  width: 100%;
  line-height: 24px;
  margin-right: 16px;
  font-size: ${(props) => (props.labelSize ? props.labelSize : '16px')};
  .ant-form-item-label {
    margin-bottom: ${(props) => (props.labelBottomMargin ? props.labelBottomMargin : 'auto')};
    color: ${leaseCreatorColors.HEADER} !important;
  }
  .ant-form-item-required {
    margin-bottom: 0;
  }
  ${media.mobile`
    margin-top: 16px;
    .ant-form-item-required {
      font-weight: 600 !important;
      margin-bottom: 2px;
      font-size: ${responsive.text.mobile};
    }
    .ant-form-item-label {
      padding-bottom: 0;
    }
    .ant-form-item-label label {
      font-weight: 600 !important;
    }
  `};
`;

const LeaseCreatorFormItem = ({
  label,
  name,
  children,
  infoMessage,
  required,
  labelSize,
  labelBottomMargin,
}) => {
  return (
    <React.Fragment>
      <StyledFormItem
        label={label}
        labelBottomMargin={labelBottomMargin}
        labelSize={labelSize}
        name={name}
        required={required}
      >
        {children}
      </StyledFormItem>
      {infoMessage && <InfoMessage message={infoMessage} />}
    </React.Fragment>
  );
};

export { LeaseCreatorFormItem };
